module.exports = __webpack_public_path__ + "img/28.Porsche2020.69de9e33.png";